var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "219DE281-E719-4583-BF85-9EA2972C3AA9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 1440,
    height: 967
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.9%",
    y: "-9.3%",
    width: "109.7%",
    height: "114.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -20,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.02 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-+-Tech-Demo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "S_Dashboard-tabs3-active",
    transform: "translate(-1254.000000, -906.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F0F2F8",
    x: 0,
    y: 0,
    width: 1440,
    height: 1800
  }), /*#__PURE__*/React.createElement("g", {
    id: "clients-list",
    transform: "translate(0.000000, 833.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F8F9FD",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(1244.000000, 63.000000)",
    stroke: "#A2A6AC",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "buttonBG",
    strokeOpacity: 0.197415865,
    fill: "#FFFFFF",
    x: -1,
    y: -1,
    width: 42,
    height: 42,
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-filter",
    transform: "translate(10.000000, 10.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3362031,2 L3.66091086,2 C3.00349354,2.0005177 2.40815078,2.38846168 2.14215959,2.98966588 C1.8761684,3.59087007 1.98951262,4.29235893 2.43130677,4.77920153 L7.924526,10.8205575 L7.924526,16.518217 C7.92462384,16.7454857 8.05469413,16.9526773 8.25933387,17.0515392 C8.33948339,17.0910612 8.42774398,17.1113509 8.51710629,17.1108083 C8.65178836,17.1108083 8.78241696,17.0647109 8.88746897,16.9804296 L9.998557,16.0915592 L11.8503704,14.6101085 C11.9907309,14.4977302 12.0724756,14.3277011 12.072588,14.1478958 L12.072588,10.8205575 L17.5658072,4.77920153 C18.0076014,4.29235893 18.1209456,3.59087007 17.8549544,2.98966588 C17.5889632,2.38846168 16.9936205,2.0005177 16.3362031,2 Z",
    id: "icon"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon-filter.dc12fb0f67fd10b69c4af6b5b0cee8ca.svg";
export { ForwardRef as ReactComponent };